import { RequestedObject } from "./RequestedObject";

export class ExternalSystemObjectValuesResponce {
  constructor(
    public isOk: boolean,
    public message: string,
    public objects: RequestedObject[],
  ) {}
}
